import { IUser } from "../models";

export const shouldAllowAccess = (userInfo: IUser) => {
  const subscription = userInfo?.subscriptionInfo;
  if (subscription?.billingMode === "MANUAL") {
    const manualBilling = subscription.manualBilling;
    const now = Date.now();
    const startsAt = Date.parse(manualBilling?.accessStartsAt || "");
    const graceEndsAt = Date.parse(manualBilling?.graceEndsAt || "");
    const transitionAt = Date.parse(manualBilling?.stripeTransition?.effectiveAt || "");
    const coveredByPreviousStripeTerm =
      manualBilling?.stripeTransition?.timing === "AT_PERIOD_END" &&
      Number.isFinite(transitionAt) &&
      now < transitionAt;
    const manualAccessActive =
      Number.isFinite(startsAt) &&
      Number.isFinite(graceEndsAt) &&
      now >= startsAt &&
      now <= graceEndsAt;
    return coveredByPreviousStripeTerm || manualAccessActive || userInfo.isAdmin;
  }

  return (
    (userInfo &&
      subscription &&
      subscription.packageId &&
      subscription.status === "PAYMENT_COMPLETED") ||
    userInfo.isAdmin
  );
};
